import './styles.css';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { LandingItem } from './item';
import { AdminButtons } from './export-buttons';
import { useContext } from 'react';
import { ProfileContext } from '../../contexts';

export const Home = ({ data }) => {
  const navigate = useNavigate();
  const { profile } = useContext(ProfileContext);

  const isActive = !profile?.deadline?.isDeadlineOver;

  return (
    <div className="App-content">
      {data.map((el) => (
        <LandingItem key={el.ID} item={el} />
      ))}
      <div className="App-row links">
        {isActive || profile?.isAdmin ? (
          <>
            <Button onClick={() => navigate('/mentor')} variant="contained">
              Mentor Form
            </Button>
            <Button onClick={() => navigate('/mentee')} variant="contained">
              Mentee Form
            </Button>
          </>
        ) : null}
        <AdminButtons />
        {profile?.nar_membership_type === 'S' ? (
          <>
            <Button
              onClick={() => navigate('/admin/mentor/dashboard')}
              variant="contained"
            >
              Go to mentor dashboard
            </Button>
            <Button
              onClick={() => navigate('/admin/mentee/dashboard')}
              variant="contained"
            >
              Go to mentee dashboard
            </Button>
          </>
        ) : null}
      </div>
    </div>
  );
};
